import { html, View } from 'rune-ts';
import klass from './ProductThumbnail.module.scss';
import { htmlIf } from '../../../../shared/util';
import { ProductThumbnail, ProductThumbnailOption } from '@services/MarppleShop/features/ProductList/type';
import { thumbnailViewTransformer } from '@services/MarppleShop/renderApp/components/cells/ProductThumbnail/transform/thumbnailViewTransformer.ts';

interface ProductThumbnailViewProps {
  thumbnail: ProductThumbnail;
  options: ProductThumbnailOption;
}

/**
 * @see {thumbnailViewTransformer}
 * DB에서 조회한 썸네일 데이터를 가공하는 함수입니다.
 *
 * TODO: @kjj value object로 만들면 깔끔할지도?
 */
export class ProductThumbnailView extends View<ProductThumbnailViewProps> {
  override template() {
    const { thumbnail, options } = this.data;

    return html`
      <figure class="${klass.product_thumbnail} ${options.klass || ''}">
        <img
          class="${klass.image} ${htmlIf('lazy-src', !!options.is_lazy)}"
          ${options.is_lazy ? 'data-src' : 'src'}="${this.resizedImageUrl}"
          ${thumbnail ? html`data-composite_template_id="${thumbnail.composite_template_id}"` : ''}
          alt="${options.img_alt}"
          style="${this.styles}"
        />
      </figure>
    `;
  }

  private get styles() {
    return thumbnailViewTransformer.createStyle(this.data.thumbnail, this.dimensions);
  }

  private get dimensions() {
    return thumbnailViewTransformer.calculateDimensions(
      this.data.thumbnail.scale,
      this.data.options.resize_width,
    );
  }

  private get resizedImageUrl() {
    return thumbnailViewTransformer.createResizedUrl(this.data.thumbnail, this.dimensions);
  }
}
